/**
 * Speaker - a Social Network for Language Learners
 * Final Project - Shay Peretz and Hanna Koval
 * The National School for Practical Engineers at the Technion
 */

import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./general.css";
import "@fontsource/roboto";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PublicLayout from "./layouts/publicLayout/PublicLayout";
import AuthLayout from "./layouts/authLayout/AuthLayout";
import LoginLayout from "./layouts/loginLayout/LoginLayout";

import PublicHomePage from "./pages/public/publicHomePage/PublicHomePage";
import LoginPage from "./pages/public/loginPage/LoginPage";
import PrivacyPolicyPage from "./pages/public/privacyPolicyPage/PrivacyPolicyPage";
import ContactPage from "./pages/authenticated/contactPage/ContactPage";
import SettingsPage from "./pages/authenticated/settingsPage/SettingsPage";
import PageNotFound from "./pages/public/pageNotFound/PageNotFound";
import AuthHomepage from "./pages/authenticated/authHomepage/AuthHomepage";
import ProfilePage from "./pages/authenticated/profilePage/ProfilePage";
import OtherUserProfilePage from "./pages/authenticated/profilePage/OtherUserProfilePage";
import MailboxPage from "./pages/authenticated/mailboxPage/MailboxPage";
import LanguagePalsPage from "./pages/authenticated/languagePalsPage/LanguagePalsPage";
import SearchPage from "./pages/authenticated/searchPage/SearchPage";
import LearningZonesPage from "./pages/authenticated/learningZonesPage/LearningZonesPage";
import LearningZonePage from "./pages/authenticated/learningZonePage/LearningZonePage";
import AdminPage from "./pages/authenticated/adminPage/AdminPage";
import RegistrationPage from "./pages/public/registrationPage/RegistrationPage";
import ForgotPassword from "./pages/public/forgotPassword/ForgotPassword";
import ResetPasswordForm from "./pages/public/forgotPassword/ResetPasswordForm";

const App = () => {
  useEffect(() => {
    document.title = "Speaker";
  }, []);

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route
          path="/"
          element={
            <PublicLayout>
              <PublicHomePage />
            </PublicLayout>
          }
        />
        {/* Password recovery */}
        <Route
          path="/passwordRecovery"
          element={
            <LoginLayout>
              <ForgotPassword />
            </LoginLayout>
          }
        />
        {/* Password reset form */}
        <Route
          path="/reset_password"
          element={
            <LoginLayout>
              <ResetPasswordForm />
            </LoginLayout>
          }
        />
        {/*Login*/}
        <Route
          path="/login"
          element={
            <LoginLayout>
              <LoginPage />
            </LoginLayout>
          }
        />
        <Route
          path="/register"
          element={
            <LoginLayout>
              <RegistrationPage />
            </LoginLayout>
          }
        />

        <Route
          path="/contact"
          element={
            <PublicLayout>
              <ContactPage />
            </PublicLayout>
          }
        />

        <Route
          path="/privacy"
          element={
            <PublicLayout>
              <PrivacyPolicyPage />
            </PublicLayout>
          }
        />

        {/* Authenticated routes */}
        <Route
          path="/home"
          element={
            <AuthLayout>
              <AuthHomepage />
            </AuthLayout>
          }
        />
        <Route
          path="/profile"
          element={
            <AuthLayout>
              <ProfilePage />
            </AuthLayout>
          }
        />

        <Route
          path="/profile/:username"
          element={
            <AuthLayout>
              <OtherUserProfilePage />
            </AuthLayout>
          }
        />

        <Route
          path="/settings"
          element={
            <AuthLayout>
              <SettingsPage />
            </AuthLayout>
          }
        />
        <Route
          path="/mailbox"
          element={
            <AuthLayout>
              <MailboxPage />
            </AuthLayout>
          }
        />
        <Route
          path="/pals"
          element={
            <AuthLayout>
              <LanguagePalsPage isOwnProfile={true} />
            </AuthLayout>
          }
        />

        <Route
          path="/pals/:username"
          element={
            <AuthLayout>
              <LanguagePalsPage isOwnProfile={false} />
            </AuthLayout>
          }
        />

        <Route
          path="/search"
          element={
            <AuthLayout>
              <SearchPage />
            </AuthLayout>
          }
        />
        <Route
          path="/learningZones"
          element={
            <AuthLayout>
              <LearningZonesPage />
            </AuthLayout>
          }
        />

        <Route
          path="/learningZone/:learningZoneId"
          element={
            <AuthLayout>
              <LearningZonePage />
            </AuthLayout>
          }
        />

        <Route
          path="/acontact"
          element={
            <AuthLayout>
              <ContactPage />
            </AuthLayout>
          }
        />

        <Route
          path="/aprivacy"
          element={
            <AuthLayout>
              <PrivacyPolicyPage />
            </AuthLayout>
          }
        />

        <Route
          path="/admin"
          element={
            <AuthLayout requiredRole="Admin">
              <AdminPage />
            </AuthLayout>
          }
        />

        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <ToastContainer />
    </>
  );
};

export default App;
